define([
    'jQuery',
    'library/fcse-util/paramConverter',
    'library/fcse-util/url'],
    function ($, ParamConverter, Url) {
        return {
            useHashInScope: function (scope) {
                scope.setMultiplePrefixedParams(ParamConverter.fromQuery(new Url(window.location.href)).merged);
                function paramChangeHandler(event, name, value) {
                    if (event.source == event.scope) {
                        if (event.scope.name) {
                            //add prefix if needed
                            name = event.scope.name + '.' + name;
                        }
                        var url = new Url(window.location.href);
                        ParamConverter.convertParamToQuery(name, value, url.hash);
                        window.location.hash = url.getHash();
                    }
                }

                function subscribe(parent) {
                    parent.paramChange(paramChangeHandler);
                    if (parent.children.length) {
                        _.each(parent.children, function (child) {
                            subscribe(child);
                        });
                    }
                }

                subscribe(scope);
            },

            /**
             * Enables HTML5 browser history for the given scope and changes within that scope
             * As browser fallback, page reload will be triggered
             * @param scope
             * @param options On object of options
             *
             * Example options:
             * {
             *      // An object of parameters and URLs. On scopechange of theses parameters, the Base URL changes to
             *      // the given URL
             *      'scopeParamUrls': {
             *          'GlobalNames': '/de/package/destination'
             *      }
             * }
             *
             */
            enableBrowserHistory: function(scope, options){
                var options = options || {};
                var scopeParamUrls = options.scopeParamUrls || {};
                var previousParams = scope.getParams() || {};

                $( window ).bind( 'popstate', function(event){
                    // Load last page if the state is not empty
                    if (null !== event.originalEvent.state) {
                        scope.setParams(event.originalEvent.state);
                    }
                });
                var paramChangeHandler = function(event){
                    // Ignore scope changes on certain actions to avoid multiple page reloads and recursion
                    if (event.eventSource == 'setParams' ||
                        event.eventSource == 'setParam'){
                        return;
                    }

                    // Get base URL
                    var baseUrl = '?';
                    $.each(scopeParamUrls, function(name, newUrl){
                        // Check if this parameter has special baseUrl
                        if (JSON.stringify(previousParams[name]) != JSON.stringify(scope.getParam(name))){
                            baseUrl = newUrl + '?';
                        }
                    });

                    // If history is available in browser
                    if (history.pushState){
                        history.pushState(scope.getParams(), '', baseUrl + $.param(scope.getQuery()));
                    } else {
                        // Old browser fallback, trigger page reload
                        window.location.href = baseUrl + $.param(scope.getQuery());
                    }

                    // Update previous params
                    previousParams = scope.getParams();
                };
                if (history.replaceState){
                    history.replaceState(scope.getParams(), '', window.location.href);
                }
                scope.change(paramChangeHandler);
            }
        }
    });



//////////////////
// WEBPACK FOOTER
// ./~/fcse-state/urlHandling.js
// module id = 222
// module chunks = 5 6 7 8 9 10 11 12 13 14